import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Aktivitäten',
  actions: {
    clicked: 'Geklickt',
    open: 'Geöffnet',
    scheduled: 'Geplant',
    sent: 'Gesendet',
  },
  fields: {
    recipients: '{{recipients}} Empfänger',
    opened: '{{rate}} Geöffnet',
    clicked: '{{rate}} Geklickt',
    awaiting: 'Wartet auf Bestätigung',
  },
  template_types: TemplateNames,
};
